import { render } from "./Celeritas.vue?vue&type=template&id=110ea14c"
import script from "./Celeritas.vue?vue&type=script&lang=js"
export * from "./Celeritas.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__